export const environment = {
  production: true,
  firebase: { 
    apiKey: "AIzaSyCzJZ0eerIVOJO_V8paiOwDxVUX_zmX7V4",
    authDomain: "angular5-firestore-crud.firebaseapp.com",
    databaseURL: "https://angular5-firestore-crud.firebaseio.com",
    projectId: "angular5-firestore-crud",
    storageBucket: "angular5-firestore-crud.appspot.com",
    messagingSenderId: "996355537677"
  }
};



// WEBPACK FOOTER //
// ./src/environments/environment.prod.ts